import Page from "./../../components/page/PageContent/PageContent";
import Action from "./../../components/formElements/Action/Action";
import { useNavigate } from "react-router-dom";
import { Trans } from "react-i18next";

export default function ErrorPage() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Page name="error" title="Error">
      <p>
        <Trans i18nKey={"ErrorPage.errorHasOccurred"}>
          Unfortunately, an error has occurred. Our engineers were notified.&nbsp; In the
          meantime, please&nbsp;
          <Action className="btn" onClick={goBack}>
            try again
          </Action>
          .
        </Trans>
      </p>
    </Page>
  );
}
